import { t } from '@lingui/macro'
import { Button, Input, Modal } from 'antd'
import React from 'react'

type InputTextModalProps = {
    open: boolean
    title: React.ReactNode
    value: string
    onChange: (value: string) => void
    onCancel: () => void
    onSave: () => void
    placeholder?: string
    cancelText?: React.ReactNode
    saveText?: React.ReactNode
    loading?: boolean
    disabled?: boolean
}

const InputTextModal: React.FC<InputTextModalProps> = ({
    open,
    title,
    value,
    onChange,
    onCancel,
    onSave,
    placeholder,
    cancelText,
    saveText,
    loading = false,
    disabled = false
}) => {
    const resolvedCancelText = cancelText ?? t`Cancel`
    const resolvedSaveText = saveText ?? t`Save`

    return (
        <Modal
            open={open}
            title={title}
            onCancel={onCancel}
            footer={[
                <Button key='cancel' onClick={onCancel} disabled={loading}>
                    {resolvedCancelText}
                </Button>,
                <Button key='save' type='primary' onClick={onSave} loading={loading} disabled={disabled}>
                    {resolvedSaveText}
                </Button>
            ]}
        >
            <Input.TextArea value={value} onChange={(event) => onChange(event.target.value)} placeholder={placeholder} />
        </Modal>
    )
}

export default InputTextModal
